/**
 * @name PendingPaymentDialog
 * @description Modal para mostrar el 'warning' de pago pendiente
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import { Flex, Icons, MUI, Unicons, Theme, Typography } from '@styles';

const PendingPaymentDialog = (props) => {
  const {
    open,
    onClose
  } = props;

  return (
    <MUI.Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
    >
      <MUI.DialogTitle>
        <Flex.Col>
          <Typography.H5>{i18n.t('GenericMessages.paymentWarning')}</Typography.H5>
          <Typography.Text color="greyDarkAlpha">{i18n.t('GenericMessages.pendingPayment')}</Typography.Text>
        </Flex.Col>
        <MUI.DialogBoxClose onClick={onClose}>
          <Icons.Close />
        </MUI.DialogBoxClose>
      </MUI.DialogTitle>
      <MUI.DialogContent style={{ position: 'relative', overflow: 'hidden' }}>
        <Flex.Col padding="32px 32px 32px 16px">
          <Typography.Text>
            {i18n.t('GenericMessages.noLicense')}
          </Typography.Text>
        </Flex.Col>
        <Unicons.CircleExclamation size="150" color={Theme.colors.orangeAlpha} style={{ position: 'absolute', right: '-40px', bottom: '-40px', zIndex: '1' }} />
      </MUI.DialogContent>
      <MUI.DialogActions>
        <MUI.ButtonText onClick={onClose}>
          {i18n.t('DialogConfirm.understood')}
        </MUI.ButtonText>
      </MUI.DialogActions>
    </MUI.Dialog>
  );
};

PendingPaymentDialog.propTypes = {
  // Boolean que indica si el modal esta abierto.
  open: PropTypes.bool.isRequired,
  // Función que se ejecuta para cerrar el modal.
  onClose: PropTypes.func.isRequired
};

export default PendingPaymentDialog;